
export default function EventRewards() {
  const topRewards = [
    {
      rank: 1,
      medal: '🥇',
      title: '1등',
      subtitle: 'Top Committer',
      reward: '1 MO',
      gradient: 'from-[#FFD700] via-[#FFC107] to-[#FFB300]',
      borderColor: 'border-[#FFD700]',
      shadowColor: 'shadow-[#FFD700]/30',
      bgGlow: 'bg-[#FFD700]/10',
      isTop: true,
    },
    {
      rank: 2,
      medal: '🥈',
      title: '2등',
      subtitle: 'Runner-up',
      reward: '0.5 MO',
      gradient: 'from-[#C0C0C0] via-[#B8B8B8] to-[#A8A8A8]',
      borderColor: 'border-[#C0C0C0]',
      shadowColor: 'shadow-[#C0C0C0]/30',
      bgGlow: 'bg-[#C0C0C0]/10',
      isTop: false,
    },
    {
      rank: 3,
      medal: '🥉',
      title: '3등',
      subtitle: 'Third Place',
      reward: '0.1 MO',
      gradient: 'from-[#CD7F32] via-[#B87333] to-[#A0522D]',
      borderColor: 'border-[#CD7F32]',
      shadowColor: 'shadow-[#CD7F32]/30',
      bgGlow: 'bg-[#CD7F32]/10',
      isTop: false,
    },
  ];

  return (
    <section id="event-rewards" className="bg-[#0D1B2A] py-10 sm:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
        {/* Title */}
        <div className="text-center mb-6 sm:mb-16 lg:mb-20">
          <div className="inline-flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-1 sm:py-2 bg-[#D4AF37]/10 rounded-full mb-3 sm:mb-6">
            <span className="text-lg sm:text-2xl">🎁</span>
            <span className="text-[#D4AF37] font-semibold text-xs sm:text-lg">Event Rewards</span>
          </div>
          <h2 className="text-xl sm:text-4xl lg:text-6xl font-bold text-white mb-2 sm:mb-6">
            항해의 결실: 이벤트 보상
          </h2>
          <div className="flex justify-center">
            <div className="w-12 sm:w-24 lg:w-32 h-0.5 bg-[#D4AF37]"></div>
          </div>
          <p className="text-xs sm:text-xl lg:text-2xl text-white/80 mt-3 sm:mt-8 max-w-3xl mx-auto leading-relaxed px-2">
            뉴베드포드 항해에 함께한 커미터들에게 드리는 특별한 보상
          </p>
        </div>

        {/* Top 3 Rewards */}
        <div className="grid grid-cols-3 gap-2 sm:gap-6 lg:gap-8 mb-6 sm:mb-16">
          {topRewards.map((item, index) => (
            <div
              key={index}
              className={`relative ${item.isTop ? 'md:-mt-4 md:scale-105 z-10' : ''}`}
            >
              <div
                className={`relative bg-[#1A2332] rounded-lg sm:rounded-3xl overflow-hidden border ${item.borderColor} sm:border-2 hover:-translate-y-2 transition-all duration-300 hover:shadow-2xl ${item.shadowColor} cursor-pointer`}
              >
                {/* Top Glow Effect */}
                <div className={`absolute top-0 left-0 right-0 h-12 sm:h-32 ${item.bgGlow} blur-2xl`}></div>

                {/* Medal Header */}
                <div className={`relative bg-gradient-to-r ${item.gradient} p-2 sm:p-6 lg:p-8 text-center`}>
                  <span className="text-2xl sm:text-6xl lg:text-7xl drop-shadow-lg">{item.medal}</span>
                  <h3 className="text-sm sm:text-2xl lg:text-3xl font-bold text-white mt-0.5 sm:mt-3 drop-shadow-md">{item.title}</h3>
                  <p className="text-white/90 text-[8px] sm:text-base mt-0 sm:mt-1 hidden sm:block">{item.subtitle}</p>
                </div>

                {/* Reward Amount */}
                <div className="relative p-2 sm:p-6 lg:p-8 text-center">
                  <div className="mb-1 sm:mb-4">
                    <span className="text-[#D4AF37] text-[8px] sm:text-base font-medium uppercase tracking-wider">보상</span>
                  </div>
                  <div className="text-base sm:text-5xl lg:text-6xl font-bold text-white mb-0.5 sm:mb-2">
                    {item.reward}
                  </div>
                  <div className="w-6 sm:w-16 h-0.5 bg-[#D4AF37]/30 mx-auto mt-1.5 sm:mt-4"></div>
                </div>

                {/* Decorative Corner */}
                {item.isTop && (
                  <div className="absolute top-1 right-1 sm:top-4 sm:right-4">
                    <div className="w-4 h-4 sm:w-8 sm:h-8 flex items-center justify-center bg-[#D4AF37] rounded-full">
                      <i className="ri-star-fill text-white text-[8px] sm:text-sm"></i>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Participation Reward */}
        <div className="mb-6 sm:mb-16">
          <div className="bg-gradient-to-r from-[#1A2332] to-[#0D1B2A] rounded-xl sm:rounded-3xl p-4 sm:p-8 lg:p-10 border border-[#D4AF37]/20 hover:border-[#D4AF37]/40 transition-all duration-300">
            <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6 lg:gap-10">
              {/* Icon */}
              <div className="flex-shrink-0">
                <div className="w-14 h-14 sm:w-24 sm:h-24 rounded-full bg-gradient-to-br from-[#D4AF37]/20 to-[#D4AF37]/5 flex items-center justify-center border-2 border-[#D4AF37]/30">
                  <span className="text-2xl sm:text-5xl">✨</span>
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 text-center sm:text-left">
                <h3 className="text-lg sm:text-3xl font-bold text-white mb-1.5 sm:mb-3">참여 보상</h3>
                <p className="text-white/70 text-xs sm:text-lg lg:text-xl leading-relaxed mb-2 sm:mb-4">
                  최소 요건 <span className="text-[#D4AF37] font-semibold">(0.01 MO, 7일 이상)</span> 충족자 전원에게 지급(구글폼 제출해주신 모든분들)
                </p>
              </div>

              {/* Reward Badge */}
              <div className="flex-shrink-0 w-full sm:w-auto">
                <div className="bg-[#D4AF37]/10 rounded-lg sm:rounded-2xl px-5 sm:px-8 py-3 sm:py-6 border border-[#D4AF37]/30">
                  <div className="text-center">
                    <span className="text-[#D4AF37] text-[10px] sm:text-sm font-medium uppercase tracking-wider block mb-0.5 sm:mb-2">보상</span>
                    <span className="text-xl sm:text-4xl font-bold text-white">0.01 MO</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Important Notice - Receipt Guide */}
        <div className="bg-[#0A1628] rounded-xl sm:rounded-3xl overflow-hidden border border-white/10">
          {/* Header */}
          <div className="bg-gradient-to-r from-[#D4AF37]/20 to-[#D4AF37]/5 px-3 sm:px-8 py-3 sm:py-6 border-b border-[#D4AF37]/20">
            <div className="flex items-center gap-2 sm:gap-3">
              <span className="text-lg sm:text-2xl">📍</span>
              <h3 className="text-base sm:text-2xl lg:text-3xl font-bold text-white">중요 수령 안내</h3>
            </div>
          </div>

          {/* Content */}
          <div className="p-3 sm:p-8 lg:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-8 mb-4 sm:mb-8">
              {/* Location */}
              <div className="flex items-start gap-2.5 sm:gap-4">
                <div className="w-9 h-9 sm:w-12 sm:h-12 flex-shrink-0 rounded-lg sm:rounded-xl bg-[#D4AF37]/10 flex items-center justify-center">
                  <i className="ri-map-pin-2-fill text-[#D4AF37] text-base sm:text-xl"></i>
                </div>
                <div>
                  <h4 className="text-sm sm:text-xl font-semibold text-white mb-0.5 sm:mb-2">수령 장소</h4>
                  <p className="text-white/70 text-xs sm:text-lg leading-relaxed">
                    수원모빅회관 방문 수령<br />
                    <span className="text-[#D4AF37]">(종이지갑 형태)</span>
                  </p>
                </div>
              </div>

              {/* Verification */}
              <div className="flex items-start gap-2.5 sm:gap-4">
                <div className="w-9 h-9 sm:w-12 sm:h-12 flex-shrink-0 rounded-lg sm:rounded-xl bg-[#D4AF37]/10 flex items-center justify-center">
                  <i className="ri-shield-check-fill text-[#D4AF37] text-base sm:text-xl"></i>
                </div>
                <div>
                  <h4 className="text-sm sm:text-xl font-semibold text-white mb-0.5 sm:mb-2">본인 확인</h4>
                  <p className="text-white/70 text-xs sm:text-lg leading-relaxed">
                    닉네임 + 커밋먼트(락업) 내역<br />
                    <span className="text-[#D4AF37]">검증 후 지급</span>
                  </p>
                </div>
              </div>

              {/* Deadline */}
              <div className="flex items-start gap-2.5 sm:gap-4 sm:col-span-2">
                <div className="w-9 h-9 sm:w-12 sm:h-12 flex-shrink-0 rounded-lg sm:rounded-xl bg-[#D4AF37]/10 flex items-center justify-center">
                  <i className="ri-calendar-check-fill text-[#D4AF37] text-base sm:text-xl"></i>
                </div>
                <div>
                  <h4 className="text-sm sm:text-xl font-semibold text-white mb-0.5 sm:mb-2">보상 수령 기한</h4>
                  <p className="text-white/70 text-xs sm:text-lg leading-relaxed">
                    수령 가능 기간: <span className="text-[#D4AF37] font-semibold">이벤트 종료 후 ~ 2026년 4월 18일까지</span>
                  </p>
                </div>
              </div>
            </div>

            {/* Message Banner */}
            <div className="bg-gradient-to-r from-[#D4AF37]/10 via-[#D4AF37]/5 to-[#D4AF37]/10 rounded-lg sm:rounded-2xl p-3 sm:p-6 border border-[#D4AF37]/20">
              <div className="flex items-start sm:items-center gap-2 sm:gap-4">
                <div className="w-7 h-7 sm:w-10 sm:h-10 flex-shrink-0 rounded-full bg-[#D4AF37]/20 flex items-center justify-center">
                  <i className="ri-double-quotes-l text-[#D4AF37] text-xs sm:text-lg"></i>
                </div>
                <p className="text-white/90 text-xs sm:text-lg lg:text-xl italic leading-relaxed">
                  &ldquo;온라인의 약속을 오프라인의 만남으로! 회관에서 커미터들과 항해의 기쁨을 나누어 보세요.&rdquo;
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
